'use strict';

function _WealthController() {
  this.id = null;
  this.node = null;
  this.extends = [_AccountController];
  this.declaredClass = null;

  this.init = function () {
    this._super();

    this.moneyUpGuard(); // feature flag check

    this._productSettings = new ProductSettings(this.presenter);
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {};

  this.moneyUpGuard = function () {
    // NOTE: tied to an element class in the portals nav.pug file.
    var isMoneyUpEnabled = $('.js--money-up-enabled');
    if (isMoneyUpEnabled.length === 0) {
      this.history.goToUrl(this.paths.account.dashboard);
    }
  };
}